import React, { useEffect, useState } from 'react'
import { Accordion, Col, Row } from 'react-bootstrap'
import { IDepartmentEmps } from '../../Structure/Interfaces/ResponsesData'
import InteractiveCheckBox from '../Utilities/InteractiveCheckBox'
import ListEmployee from './ListEmployee'
import { EmpListsVM } from '../../Structure/ViewModels/Admin/EmpListsVM'

const DepartmentEmployees = (props:{Department:IDepartmentEmps ,roles:{id:string , role:string}[] , vm:EmpListsVM}) => {
  const [vm,setVm] = useState<{viewModel:EmpListsVM}>({viewModel:props.vm})
  const control = vm.viewModel
  useEffect(()=>control.subscribeUpdate(setVm),[])

    return (
    <Accordion.Item eventKey={props.Department.id} className='w-100 rounded-0' style={{outline:'none' , borderRadius:'0px'}}>
    <Accordion.Button className='border-0 border-bottom-0' style={{outline:'none', border:'none' , borderRadius:'0px', boxShadow:'none'}}>
          <h5 className='px-3'>{props.Department.role}</h5>
    </Accordion.Button>
    <Accordion.Body className=' overflow-y-auto'  style={{maxHeight:'400px'}}>
      <Row>
          <Col lg={8}>
            <div className='p-3'>
                {
                    props.Department.users.map((item,index)=>(
                        <ListEmployee key={index} user={item} index={index} role={{id:props.Department.id,role:props.Department.role}} roles={props.roles} vm={control} />
                    ))
                }
            </div>
          </Col>
          <Col lg={4} className='p-3'>
            <div className='border p-3'>
                <h5 className='text-center'>الصلاحيات</h5>
                <div className='py-2 d-flex flex-wrap d-lg-block'>
                    {
                        props.Department.permissions.map((item , index)=>(
                            <div key={index} className='p-1'>
                              <input disabled={props.Department.role ==='الأدارة'} type="checkbox" id={props.Department.id+'-'+item.id} defaultChecked ={item.submitted} onChange={a=>control.updatePermission(props.Department.id, item.id, a.target.checked?'enable':'disable')} className='btn-cl-I' />
                              <label htmlFor={props.Department.id+'-'+item.id} className='px-2'>{item.permission}</label>
                            </div>
                        ))
                    }
                </div>
            </div>
          </Col>
      </Row>
    </Accordion.Body>
  </Accordion.Item>
  )
}

export default DepartmentEmployees
